import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ProcessedError, UserInfo } from 'src/shared/models';
import { AuthService } from 'src/shared/services/auth.service';
import { FormValidationService } from 'src/shared/services/form-validation.service';
import { LanguageService } from 'src/shared/services/language.service';
import { TokenService } from 'src/shared/services/token.service';
import { UserInformationService } from 'src/shared/services/user-information.service';
import { UserNotificationService } from 'src/shared/services/user.notification.service';

@Component({
  selector: 'organism-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent implements OnInit {
  loginForm:FormGroup;
  showPassword = false;

  constructor(private fb: FormBuilder, private router:Router, private formValidationService:FormValidationService,
    private authService:AuthService, private userNotificationService: UserNotificationService, private tokenService:TokenService,
    private languageService: LanguageService, private userInformationService:UserInformationService, private cdr: ChangeDetectorRef) {
    this.loginForm = this.fb.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]]
    });
  }

  ngOnInit(): void {
    this.setupAutoTrim();
  }

  private setupAutoTrim(): void {
    ['username', 'password'].forEach(fieldName => {
      this.loginForm.get(fieldName)?.valueChanges.subscribe(value => {
        if (value && typeof value === 'string') {
          const trimmedValue = value.trim();
          if (value !== trimmedValue) {
            this.loginForm.get(fieldName)?.setValue(trimmedValue, { emitEvent: false });
          }
        }
      });
    });
  }

  onTogglePassword(): void {
    this.showPassword = !this.showPassword;
  }

  onSubmit():void {
    if(this.loginForm.valid){
      // Aplicar trim a los valores para eliminar espacios al inicio y final
      const username = this.loginForm.value.username?.trim() || '';
      const password = this.loginForm.value.password?.trim() || '';
      this.authenticateUser(username, password);
    } else {
      this.loginForm.markAllAsTouched();
    }
  }

  isValidField(field: string): boolean | null {
    return this.formValidationService.isValidField(this.loginForm.controls[field]);
  }

  getFieldError(field: string): string {
    return this.formValidationService.getFieldError(this.loginForm.controls[field]) || '';
  }

  private authenticateUser(username: string, password:string):void {
    this.authService.Post(username, password).subscribe({
      next: (response) => {
        if(response.token){
          const expirationTimeMilliseconds = response.expirationDuration;

          if (!isNaN(expirationTimeMilliseconds) && expirationTimeMilliseconds > 0) {
            const expirationTimestamp = Date.now() + expirationTimeMilliseconds;

            this.tokenService.saveToken(response.token, expirationTimestamp);

            const userInfo:UserInfo = {
              nombre: response.nombre,
              apellido: response.apellido,
              usuario: response.usuario,
              roles: response.roles,
              userId: response.userId,
              userIp: response.userIp,
              companyId: response.companyId,
              companyName: response.companyName,
            };
            sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
            const idUser = userInfo?.userId.toString();
            this.getUserProfile(idUser);
          } else {
            this.userNotificationService.showError("ALERTS.NO-TOKEN");
          }
        }
      },
      error: (error:ProcessedError) => {
        const message = error.errorMessage === 'Credenciales de acceso inválidas' ? 'ALERTS.INVALID-CREDENTIALS' : 'ALERTS.GENERAL-ERROR';
        this.userNotificationService.showError(message);
      }
    })
  }

  private getUserProfile(idUser:string){
    const body = {
      "usuario": idUser
    }
    this.userInformationService.Post(body).subscribe({
      next: (response) => {
        if(response['public userInformation'].perfil){
          sessionStorage.setItem('userProfile', JSON.stringify(response['public userInformation']));
          this.router.navigateByUrl('/home');
          } else {
          this.userNotificationService.showError('No existe información para el usuario.');
        }
      },
      error: (error:ProcessedError) => {
        this.userNotificationService.showError(error.errorMessage);
      },
    })
  }
}
